import styled from 'styled-components'
import { BLACK, WHITE } from '../../styles/colors'

export const Container = styled.div<{ $borderColor: string; $backgroundColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  border: 1px dashed ${({ $borderColor }) => $borderColor};
  border-radius: 12px;
  padding: 16px 0;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  cursor: pointer;
` as any

export const IconContainer = styled.div<{ size: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: ${WHITE};
  background-color: ${BLACK};
  width: ${({ size }) => 10 + size}px;
  height: ${({ size }) => 10 + size}px;
  border-radius: 100%;
` as any

export const Label = styled.span<{ fontSize: number | string }>`
  color: ${BLACK};
  font-size: ${({ fontSize }) => fontSize};
` as any
